export default {
  NuCalNumberOfNightsView: {
    incrementButtonAria: "Zahl der \u00DCbernachtungen um 1 erh\u00F6hen",
    decrementButtonAria: "Zahl der \u00DCbernachtungen um 1 verringern",
  },
  NuCalAnnouncerView: {
    arrivalText: "Das Datum der Ankunft ist der [date].",
    departureText: "Das Datum der Abreise ist der [date].",
  },
  NuCalSingleCalendarView: {
    nextLabel: "Weiter",
    nextLabelAria: "N\u00E4chster Monat",
    previousLabel: "Zur\u00FCck",
    previousLabelAria: "Vorheriger Monat",
  },
  NuCalSelectView: {
    departure: {
      dayLabel: "Tag",
      daySelectAria: "Tag der Abreise",
      monthLabel: "Monat",
      monthSelectAria: "Monat der Abreise",
      yearLabel: "Jahr",
      yearSelectAria: "Jahr der Abreise",
    },
    arrival: {
      dayLabel: "Tag",
      daySelectAria: "Tag der Ankunft",
      monthLabel: "Monat",
      monthSelectAria: "Monat der Ankunft",
      yearLabel: "Jahr",
      yearSelectAria: "Jahr der Ankunft",
    },
  },
};
